/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompleteUserBook } from '../models/CompleteUserBook';
import type { NewUserBook } from '../models/NewUserBook';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserCreatedBooksService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all the books based on the given search params. Only return public books.
     * @param title key words in the title of the book
     * @param author key words corresponding to the author of the book
     * @param authorId the id of the author that you would like to retrieve the given books for (only return public books if the current user is not the corresponding offer)
     * @returns CompleteUserBook list of books
     * @throws ApiError
     */
    public listUserCreatedBooks(
        title?: string,
        author?: string,
        authorId?: string,
    ): CancelablePromise<Array<CompleteUserBook>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/userCreatedBooks',
            query: {
                'title': title,
                'author': author,
                'authorId': authorId,
            },
        });
    }

    /**
     * Add a new user created book to the database
     * @param requestBody the book to be added
     * @returns any Ok
     * @throws ApiError
     */
    public createBook(
        requestBody: NewUserBook,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/userCreatedBooks',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * List all the books for a given author query by the title provided.
     * @param authorId the id of the given author
     * @param title the string to search the title based on
     * @returns CompleteUserBook a list of books for the given author
     * @throws ApiError
     */
    public getBooksForAuthor(
        authorId: string,
        title?: string,
    ): CancelablePromise<Array<CompleteUserBook>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/userCreatedBooks/booksForAuthor/{authorId}',
            path: {
                'authorId': authorId,
            },
            query: {
                'title': title,
            },
        });
    }

    /**
     * Return a single book based on its id.
     * @param bookId the id of the book
     * @returns CompleteUserBook single book
     * @throws ApiError
     */
    public getUserCreatedBook(
        bookId: string,
    ): CancelablePromise<CompleteUserBook> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/userCreatedBooks/{bookId}',
            path: {
                'bookId': bookId,
            },
        });
    }

    /**
     * update a given book with the given id
     * @param bookId
     * @param requestBody the updated book
     * @returns void
     * @throws ApiError
     */
    public updateBook(
        bookId: string,
        requestBody: CompleteUserBook,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/userCreatedBooks/{bookId}',
            path: {
                'bookId': bookId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
